import { render, staticRenderFns } from "./dragable.vue?vue&type=template&id=3dada274&scoped=true&"
import script from "./dragable.vue?vue&type=script&lang=js&"
export * from "./dragable.vue?vue&type=script&lang=js&"
import style0 from "./dragable.vue?vue&type=style&index=0&id=3dada274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dada274",
  null
  
)

export default component.exports